import React from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { Stack, Button, Tooltip } from '@mui/material'
import { hideFormModal } from 'state/ui'
import { MODAL_VIEW_MODES, ENTITY_IN_LOCK_PERIOD_MESSAGE } from 'utils/constants'

const FormModalActionBar = ({
  submitActionText,
  submitDisabled,
  cancelActionText,
  editActionText,
  deleteActionText,
  onDelete,
  onCancel,
  onEdit,
  isInLockedAccountingPeriodV2,
  viewMode,
  isFormEditable,
  isFormVoidable,
}) => {
  const dispatch = useDispatch()

  const handleCancelClick = () => {
    if (onCancel) {
      onCancel()
    } else {
      dispatch(hideFormModal())
    }
  }

  const handleEditClick = () => {
    if (onEdit) {
      onEdit()
    }
  }

  const handleDeleteClick = () => {
    if (onDelete) {
      onDelete()
    }
  }

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      p={2}
      sx={{
        boxShadow:
          '0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px rgba(0, 0, 0, 0.14), 0px 1px 8px rgba(0, 0, 0, 0.12)',
      }}
    >
      {viewMode === MODAL_VIEW_MODES.NEW && (
        <Button onClick={handleCancelClick} variant="outlined">
          {cancelActionText}
        </Button>
      )}

      {viewMode === MODAL_VIEW_MODES.EDIT && (
        <Stack direction="row" spacing={2}>
          <Tooltip title={isInLockedAccountingPeriodV2 ? ENTITY_IN_LOCK_PERIOD_MESSAGE : ''}>
            <div>
              <Button type="submit" disabled={submitDisabled || isInLockedAccountingPeriodV2} variant="contained">
                Save Changes
              </Button>
            </div>
          </Tooltip>
          <Button onClick={handleCancelClick} variant="outlined">
            {cancelActionText}
          </Button>
        </Stack>
      )}

      {viewMode === MODAL_VIEW_MODES.VIEW && (
        <Stack direction="row" spacing={2}>
          <Button onClick={handleCancelClick} variant="outlined">
            {cancelActionText}
          </Button>
          {isFormEditable && (
            <Tooltip title={isInLockedAccountingPeriodV2 ? ENTITY_IN_LOCK_PERIOD_MESSAGE : ''}>
              <div>
                <Button onClick={handleEditClick} variant="outlined" disabled={isInLockedAccountingPeriodV2}>
                  {editActionText}
                </Button>
              </div>
            </Tooltip>
          )}
        </Stack>
      )}

      {viewMode === MODAL_VIEW_MODES.NEW && (
        <Button type="submit" disabled={submitDisabled} variant="contained">
          {submitActionText}
        </Button>
      )}
      {viewMode !== MODAL_VIEW_MODES.NEW && isFormVoidable && (
        <Tooltip title={isInLockedAccountingPeriodV2 ? ENTITY_IN_LOCK_PERIOD_MESSAGE : ''}>
          <div>
            <Button onClick={handleDeleteClick} color="error" disabled={isInLockedAccountingPeriodV2}>
              {deleteActionText}
            </Button>
          </div>
        </Tooltip>
      )}
    </Stack>
  )
}

FormModalActionBar.propTypes = {
  submitActionText: PropTypes.string,
  submitDisabled: PropTypes.bool,
  cancelActionText: PropTypes.string,
  editActionText: PropTypes.string,
  deleteActionText: PropTypes.string,
  viewMode: PropTypes.string,
  onCancel: PropTypes.func,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  isInLockedAccountingPeriodV2: PropTypes.bool,
  isFormEditable: PropTypes.bool,
  isFormVoidable: PropTypes.bool,
}

FormModalActionBar.defaultProps = {
  submitActionText: 'Submit',
  submitDisabled: false,
  cancelActionText: 'Cancel',
  editActionText: 'Edit',
  deleteActionText: null,
  viewMode: MODAL_VIEW_MODES.NEW,
  onCancel: null,
  onEdit: null,
  onDelete: null,
  isInLockedAccountingPeriodV2: false,
  isFormEditable: false,
  isFormVoidable: false,
}

export default FormModalActionBar
